import { IUserWithEffectivePermissions } from "@symity-hub/types";
import { createContext } from "react";

interface SignedInUserContextProps {
    signedInUser?: IUserWithEffectivePermissions;
    setSignedInUser: React.Dispatch<React.SetStateAction<IUserWithEffectivePermissions | undefined>>;
}

export const SignedInUserContext = createContext({} as SignedInUserContextProps);
